// Tiny safe-ish markdown renderer used by BlogDetail and InstallationDetail.
// Supports: H2/H3 headings, *italic*, **bold**, unordered + ordered lists,
// blank-line paragraph breaks, > blockquotes, GFM pipe-tables. HTML is escaped.

function escapeHtml(s) {
  return String(s)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function inline(s) {
  return escapeHtml(s)
    .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
    .replace(/\*(.+?)\*/g, "<em>$1</em>");
}

function splitRow(row) {
  // Trim surrounding pipes and split on `|`. Whitespace cells are kept.
  return row
    .replace(/^\s*\|/, "")
    .replace(/\|\s*$/, "")
    .split("|")
    .map((c) => c.trim());
}

function isTableSeparator(line) {
  // | --- | :--- | ---: | :---: |
  return /^\s*\|?(\s*:?-{2,}:?\s*\|)+\s*:?-{2,}:?\s*\|?\s*$/.test(line);
}

export function renderMarkdown(md = "") {
  const lines = md.split("\n");
  const out = [];
  let inList = false;
  let inOl = false;
  const flushList = () => {
    if (inList) { out.push("</ul>"); inList = false; }
    if (inOl) { out.push("</ol>"); inOl = false; }
  };

  for (let i = 0; i < lines.length; i++) {
    let line = lines[i];

    // GFM table: header row followed by separator row of dashes.
    if (
      /^\s*\|.+\|\s*$/.test(line) &&
      i + 1 < lines.length &&
      isTableSeparator(lines[i + 1])
    ) {
      flushList();
      const header = splitRow(line);
      i += 2; // skip header + separator
      const body = [];
      while (i < lines.length && /^\s*\|.+\|\s*$/.test(lines[i])) {
        body.push(splitRow(lines[i]));
        i++;
      }
      i--; // step back so outer loop increments correctly
      out.push('<div class="md-table-wrap">');
      out.push("<table>");
      out.push(`<thead><tr>${header.map((h) => `<th>${inline(h)}</th>`).join("")}</tr></thead>`);
      out.push("<tbody>");
      for (const row of body) {
        // Pad/truncate to header width
        const cells = Array.from({ length: header.length }, (_, k) => row[k] || "");
        out.push(`<tr>${cells.map((c) => `<td>${inline(c)}</td>`).join("")}</tr>`);
      }
      out.push("</tbody></table></div>");
      continue;
    }

    if (/^##\s+/.test(line)) { flushList(); out.push(`<h2>${escapeHtml(line.replace(/^##\s+/, ""))}</h2>`); continue; }
    if (/^###\s+/.test(line)) { flushList(); out.push(`<h3>${escapeHtml(line.replace(/^###\s+/, ""))}</h3>`); continue; }
    if (/^>\s+/.test(line)) { flushList(); out.push(`<blockquote>${inline(line.replace(/^>\s+/, ""))}</blockquote>`); continue; }
    if (/^[-*]\s+/.test(line)) {
      if (!inList) { flushList(); out.push("<ul>"); inList = true; }
      out.push(`<li>${inline(line.replace(/^[-*]\s+/, ""))}</li>`);
      continue;
    }
    if (/^\d+\.\s+/.test(line)) {
      if (!inOl) { flushList(); out.push("<ol>"); inOl = true; }
      out.push(`<li>${inline(line.replace(/^\d+\.\s+/, ""))}</li>`);
      continue;
    }
    if (line.trim() === "") { flushList(); continue; }
    flushList();
    out.push(`<p>${inline(line)}</p>`);
  }
  flushList();
  return out.join("\n");
}
